// src/components/support/forms/FeeCertificate.js
import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, CertificateURL, pass } from "../../../atomstore/store";
import { childList } from "../../../atomstore/store";

import SpinnerLoading from "../../common/SpinnerLoading";
import { handleGetFeeCertificate } from "../../../queryfunctions/queryfunctions";
import FootprintDatePicker from "../../common/FootprintDatePicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../../common/CustomSelect";

const FeeCertificate = () => {
    const navigate = useNavigate();
    const { useMutationWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);
    const [, setURL] = useAtom(CertificateURL)
    const [, setPassingChild] = useAtom(pass)
    const [children] = useAtom(childList);
    const [selectedChild, setSelectedChild] = useState(0);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [error, setError] = useState("");

    const getFeeCertificate = useMutationWrapper(
        ["getFeeCertificate"],
        () => {
            console.log("[Fee Certificate] API Request:", {
                startDate,
                endDate,
                child: activeChild?.id,
            });
            return handleGetFeeCertificate(
                { startDate, endDate, child: children[selectedChild] },
                null // no navigate — handled by onSuccess
            );
        },
        {
            onSuccess: (data) => {
                console.log("[Fee Certificate] Success:", data);
                setURL(data?.response);
                setPassingChild(children[selectedChild])
                navigate('/share-certificate')

            },
        }
    );

    const validate = () => {
        if (!startDate) {
            setError("Please select From Date");
            return false;
        } else if (!endDate) {
            setError("Please select End Date");
            return false;
        }
        setError("");
        return true;
    };

    const submitRequest = () => {
        if (validate()) {
            getFeeCertificate.mutate();
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {getFeeCertificate.isLoading && <SpinnerLoading />}

            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Fee Certificate</h2>
            </div>



            {/* Body */}
            <div className="p-4 space-y-6">

                {children.length > 1 && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Select Child
                        </label>
                        <CustomSelect
                            value={selectedChild}
                            onChange={(val) => setSelectedChild(Number(val))}
                            options={children.map((child, idx) => ({
                                value: idx,
                                label: `${child.name} ${child.last_name}`,
                            }))}
                            placeholder="Select Child"
                        />
                    </div>
                )}

                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-md">
                    <p className="text-sm text-blue-800">
                        Generate fee certificate for{" "}
                        <span className="font-semibold">{children[selectedChild]?.name} {children[selectedChild]?.last_name}</span>.
                    </p>
                </div>

                {/* From Date */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        From Date
                    </label>
                    <FootprintDatePicker
                        onChange={(date) => {
                            setStartDate(moment(date));
                            setError("");
                        }}
                        inputProps={{
                            placeholder: "Select Start Date",
                        }}
                    />
                </div>

                {/* To Date */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        To Date
                    </label>
                    <FootprintDatePicker
                        onChange={(date) => {
                            setEndDate(moment(date));
                            setError("");
                        }}
                        inputProps={{
                            placeholder: "Select End Date",
                        }}
                    />
                </div>

                {/* Error */}
                {error && <p className="text-red-500 text-sm">{error}</p>}

                {/* Submit Button */}
                <button
                    onClick={submitRequest}
                    disabled={getFeeCertificate.isLoading}
                    className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold 
                               hover:bg-cyan-600 transition disabled:opacity-60"
                >
                    Generate Certificate
                </button>
            </div>
        </div>
    );
};

export default FeeCertificate;
